const navigation = JSON.parse(localStorage.getItem('navigation'))

const initialState = navigation
  ? { ...navigation }
  : { isCollapsed: false }

const state = initialState

const actions = {
  toggleCollapse ({ commit }) {
    commit('TOGGLE_COLLAPSE')
  }
}

const mutations = {
  TOGGLE_COLLAPSE (state) {
    state.isCollapsed = !state.isCollapsed
    localStorage.setItem('navigation', JSON.stringify(state))
  }
}

export default { namespaced: true, state, actions, mutations }
